import { Message } from "../interface/message.interface";
import { v4 as uuidv4 } from 'uuid';

export function generateToken() {
  // const rand = () => {
  //   return Math.random().toString(36).substr(2);
  // };

  // let longString = rand() + rand() + rand() + rand();
  return `thread_${uuidv4()}`;
}

export function pushMessage(messages: Message[], options: Message){

  const  {role, content, show, danger } = options;

  messages.push({ role, content, show: show, danger: danger });
}
